module.exports = __webpack_public_path__ + "static/bg-white-2-e49a3c0c1821a714c24bd3d80aecd4a8.jpg";